import { message } from "antd";

export const util = {
  intakes: () => {
    let intakes: Array<string> = [];
    for (let i = 0; i < 20; i++) {
      let year = 18 + i;
      intakes.push("02-" + year);
      intakes.push("09-" + year);
    }
    return intakes;
  },
  intakeYears: () => {
    let years: Array<string> = [];
    for (let i = 0; i < 20; i++) {
      let year = 18 + i + "";
      years.push(year);
    }
    return years;
  },
  handleError: (data) => {
    if (data) {
      const errorData = data.detail;
      let errorMessage = data.message + ": ";
      if (errorData.fields) {
        const fields = errorData.fields;
        for (const identifier of Object.keys(fields)) {
          if (fields[identifier] === "1") {
            errorMessage += identifier + " is missing.";
          } else {
            errorMessage += identifier + ": " + fields[identifier];
          }
        }
        message.error(errorMessage);
      }
    }
  },
  intakeMonths: () => {
    return [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
  },
  currentIntake: () => {
    return "Feb-" + new Date().getFullYear().toString().substring(2);
  },
  calculateResult: (assessmentResults) => {
    const obj = {};
    for (const item of assessmentResults) {
      const percentage = item.percentage;
      const assessmentID = item.assessment_id;
      const repeat = item.is_repeat;
      const score = item.score;
      if (repeat) {
        if (obj[assessmentID] && obj[assessmentID]["score"] < score) {
          obj[assessmentID]["score"] = score;
        }
        continue;
      }
      obj[assessmentID] = { score: score, percentage: percentage };
    }

    let result = 0;
    let totalPercentage = 0;
    for (const key of Object.keys(obj)) {
      const item = obj[key];
      totalPercentage += item["percentage"];
      result = result + (item["score"] * item["percentage"]) / 100;
    }

    if (totalPercentage <= 99.5) {
      return "-";
    }

    return result;
  },
  washResult: (result) => {
    if (typeof result === "number") {
      return result.toFixed(2);
    } else {
      return result;
    }
  },
  getResultsAverage: (assessmentResults, allSubjects, isBachelor = true) => {
    let result = 0;
    const totalCredit = isBachelor ? 60 : 90;
    let hasOptional = false;
    for (const subject of allSubjects) {
      if (subject.is_optional) {
        hasOptional = true;
        break;
      }
    }

    let creditHavingResult = 0;
    let optionalResults = [];
    //set mandatory result
    for (const subject of allSubjects) {
      const subjectAssessmentResults = assessmentResults.filter(
        (item) => item.subject_id === subject.id,
      );
      const subjectResult = util.calculateResult(subjectAssessmentResults);
      const credit = subject.credit;
      if (subjectResult !== "-") {
        if (subject.is_optional) {
          optionalResults.push({ result: subjectResult, credit: credit });
        } else {
          result = result + (subjectResult * credit) / totalCredit;
          creditHavingResult += parseInt(credit);
        }
      } else {
        // if there is no optional subject and has '-', return '-'
        if (!hasOptional) {
          return "-";
        }
      }
    }
    //set optional result
    optionalResults.sort((a, b) => {
      if (a.result > b.result) {
        return 1;
      } else if (a.result === b.result) {
        return -1;
      } else {
        return 0;
      }
    });

    let maxLength = isBachelor ? 3 : 2;
    for (
      let i = 0;
      i <
      (optionalResults.length > maxLength ? maxLength : optionalResults.length);
      i++
    ) {
      const item = optionalResults[i];
      result = result + (item.result * item.credit) / totalCredit;
      creditHavingResult += parseInt(item.credit);
    }

    if (creditHavingResult !== totalCredit) {
      return "-";
    }
    return result.toFixed(2);
  },
  statusList: [
    "Home Provisional",
    "International Provisional",
    "Home Successful",
    "International Successful",
    "Home Accepted",
    "International Accepted",
    "Visa Refused",
    "Visa Successful",
    "Enrolled",
    "Incompleted",
    "Withdrawn with Refund",
    "Admin Cancelled",
    "Withdrawn no Refund",
    "Graduated",
    "Pending",
  ].sort(function (a, b) {
    return a.localeCompare(b);
  }),
};
